/* Product page on-view reveal.
 * Targets every <div id="shopify-section-…"> inside #MainContent except the
 * first one (the main-product section). Adds .psr-section to each, then
 * flips on .psr-in-view via IntersectionObserver. Tags first-level children
 * of the section's first element with [data-psr-child] + --psr-i so the
 * stylesheet can stagger them. */
// document.addEventListener('DOMContentLoaded', () => {
//   const fadeElements = document.querySelectorAll('[data-fade]');
//   const scaleElements = document.querySelectorAll('[data-scale]');
//   const observer = new IntersectionObserver(
//     (entries, observer) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const el = entry.target;
//           const delay = el.dataset.delay || 0;
//           const duration = el.dataset.duration || 600;
//           el.style.transitionDuration = duration + 'ms';
//           el.style.transitionDelay = delay + 'ms';
//           el.classList.add('is-visible');
//           observer.unobserve(el); // animate only once
//         }
//       });
//     },
//     { threshold: 0.1 }
//   );
//   fadeElements.forEach((el) => observer.observe(el));
//   scaleElements.forEach((el) => observer.observe(el));
// });

var parallax_elements = gsap.utils.toArray("[gsap-parallax]");
  parallax_elements.forEach(function (element) {
    gsap.to(element, {
      yPercent: -20, 
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",  
        end: "bottom top",    
        scrub: true,       
      },
    });
});

var parallax_elements = gsap.utils.toArray("[gsap-slow-parallax]");
  parallax_elements.forEach(function (element) {
    gsap.to(element, {
      yPercent: -40, 
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",  
        end: "bottom top",    
        scrub: true,       
      },
    });
});

var parallax_m_elements = gsap.utils.toArray("[gsap-medium-parallax]");
  parallax_m_elements.forEach(function (element) {
    gsap.to(element, {
      yPercent: -10, 
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",  
        end: "bottom top",    
        scrub: true,       
      },
    });
});

var parallax_b_elements = gsap.utils.toArray("[gsap-both_r-parallax]");
  parallax_b_elements.forEach(function (element) {
    gsap.to(element, {
      yPercent: 10, 
      xPercent: 10, 
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",  
        end: "bottom top",    
        scrub: true,       
      },
    });
});

var parallax_b_elements = gsap.utils.toArray("[gsap-both-parallax]");
  parallax_b_elements.forEach(function (element) {
    gsap.to(element, {
      yPercent: -10, 
      xPercent: -10, 
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",  
        end: "bottom top",    
        scrub: true,       
      },
    });
});
var parallax_block_elements = gsap.utils.toArray("[gsap-parallax-block]");
  parallax_block_elements.forEach(function (element) {
    gsap.to(element, {
      yPercent: -20, 
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top -10%",  
        end: "bottom -60%",    
        scrub: true,       
      },
    });
});
  
var other_elements = gsap.utils.toArray("[gsap-fadin-anim]");
other_elements.forEach(function (element) {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 95%",
      end: "bottom 50%",
      toggleActions: "play none none none",
    },
  });
  tl.fromTo(
    element,
    { opacity: 0, yPercent: 20 },
    { duration: 1, opacity: 1, yPercent: 0, ease: "cubic" }
  );
});

var scale_elements = gsap.utils.toArray("[gsap-scale-anim]");
scale_elements.forEach(function (element) {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 95%",
      end: "bottom 50%",
      toggleActions: "play none none none",
    },
  });
  tl.fromTo(
    element,
    { scale: 1.5},
    { duration: 1, scale: 1, ease: "cubic" }
  );
});

var scale_d_elements = gsap.utils.toArray("[gsap-scale-d-anim]");
scale_d_elements.forEach(function (element) {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 95%",
      end: "bottom 50%",
      toggleActions: "play none none none",
    },
  });
  tl.fromTo(
    element,
    { scale: 1.75},
    { duration: 1, scale: 1, ease: "cubic" }
  );
});